import { Input } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled(Input)<{
  background?: string;
  width: number | string;
  height: string;
  fontSize?: string;
  styles?: any;
}>`
  width: ${p => (typeof p.width == 'string' ? p.width : `${p.width}px`)};
  height: ${p => p.theme.input.height[p.height]};
  background: ${p => p.background} !important;
  position: relative;

  .ant-input {
    font-size: ${p => p.theme.font.size[p.fontSize || 'xs']};
    background: ${p => p.background || '#fafafa'};

    &::placeholder {
      font-size: ${props => props.theme.font.size.xs} !important;
      color: ${props => props.theme.colors.text.secondary};
    }
  }

  ${p => p.styles}
`;

export const WrapperAction = styled.div`
  position: absolute;
  height: 42px;
  right: 12px;
  top: 0px;
  bottom: 0px;
  z-index: 10;

  display: flex;
  align-items: center;
`;

export const WrapperMobile = styled(Input)<{
  background?: string;
  width: number | string;
  height: string;
  fontSize?: string;
  styles?: any;
}>`
  width: ${p => (typeof p.width == 'string' ? p.width : `${p.width}px`)};
  height: 36px;
  background: ${p => p.background} !important;

  .ant-input {
    font-size: ${p => p.theme.font.size[p.fontSize || 'xs']};
    background: ${p => p.background || '#fafafa'};

    &::placeholder {
      font-size: ${props => props.theme.font.size.xs} !important;
      color: ${props => props.theme.colors.text.secondary};
    }
  }

  ${p => p.styles}
`;
